import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=83aac558&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=83aac558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aac558",
  null
  
)

export default component.exports